import variables from "../assets/js/variables";

const widthAndPointOfAxisLinear = (x, angle = 90) => {
  const width = x + 100;
  return { width: width, xAxis: width, angle, avgAxis: width };
};

const generatePointPosition = (sidePosition, coordinates) => {
  const staticStyle = {
    root: {
      padding: "32px",
      overflow: "unset",
    },
    before: {},
  };
  const dynamicStyle = {
    root: {},
    before: {},
  };
  if (sidePosition === "top right") {
    dynamicStyle.root = {
      left: coordinates.avgAxis - coordinates.width + "px",
    };
    dynamicStyle.before = {
      right: "100%",
    };
  } else if (sidePosition === "bottom right") {
    dynamicStyle.root = {
      left: coordinates.avgAxis - coordinates.width + "px",
    };
    dynamicStyle.before = {
      right: "100%",
    };
  } else if (sidePosition === "top left") {
    dynamicStyle.root = {
      right: coordinates.avgAxis - coordinates.width + "px",
    };
    dynamicStyle.before = {
      left: "100%",
    };
  } else if (sidePosition === "bottom left") {
    dynamicStyle.root = {
      right: coordinates.avgAxis - coordinates.width + "px",
      bottom: "-125%",
    };
    dynamicStyle.before = {
      left: "100%",
    };
  }

  return {
    root: { ...dynamicStyle.root, ...staticStyle.root },
    before: { ...dynamicStyle.before, ...staticStyle.before },
  };
};

export const getRandomIntBetween = (min, max) => {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min) + min);
};

export const whereIsPointOnContainer = (container, point) => {
  const xAxis = container.width / 2 + container.left,
    yAxis = container.height / 2 + container.top;
  const xPos = point.x,
    yPos = point.y;

  let sidePosition;
  if (xPos > xAxis && yPos < yAxis) {
    sidePosition = "top right";
  } else if (xPos > xAxis && yPos >= yAxis) {
    sidePosition = "bottom right";
  } else if (xPos <= xAxis && yPos < yAxis) {
    sidePosition = "top left";
  } else if (xPos <= xAxis && yPos >= yAxis) {
    sidePosition = "bottom left";
  }
  let ySpace, xSpace, angle;
  if (sidePosition === "top right") {
    xSpace = container.right - point.x;
    ySpace = point.y - container.top;
    angle = 0;
  } else if (sidePosition === "bottom right") {
    xSpace = container.right - point.x;
    ySpace = container.bottom - point.y;
    angle = 0;
  } else if (sidePosition === "top left") {
    xSpace = point.x - container.left;
    ySpace = point.y - container.top;
    angle = 0;
  } else if (sidePosition === "bottom left") {
    xSpace = point.x - container.left;
    ySpace = container.bottom - point.y;
    angle = 0;
    return ySpace;
    //for warning
  }

  const coordinates = widthAndPointOfAxisLinear(xSpace, angle);
  return generatePointPosition(sidePosition, coordinates);
};

export const randomDotsStyle = () => {
  const colors = ["#00EEB8", "white", variables.colors.blue];
  const getRandomInt = (max) => Math.floor(Math.random() * max);
  const getRandomIntBetween = (min, max) => {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min) + min);
  };

  const widthHeight = getRandomIntBetween(10, 40);
  return {
    width: `${widthHeight}px`,
    height: `${widthHeight}px`,
    left: `${getRandomIntBetween(0, window.innerWidth)}px`,
    top: `${getRandomIntBetween(0, window.innerHeight - 300)}px`,
    filter: `blur(${getRandomIntBetween(5, 30)}px)`,
    backgroundColor: colors[getRandomInt(3)],
  };
};
